import { Avatar, Card, Skeleton } from 'antd';
import cx from 'classnames';
import React, { type ComponentType, type FC } from 'react';
import {
  BankOutlined,
  DollarCircleOutlined,
  FlagOutlined,
  LikeOutlined,
  MailOutlined,
  NumberOutlined,
  PhoneOutlined,
  TagOutlined,
  TeamOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';

import styles from './geekskill.module.scss';

const colorMap: Record<string, string> = {
  phone: '#008000',
  ticket: '#FF8000',
  email: '#FFD700',
  csi: '#808040',
  business: '#64B1FF',
  practice: '#DA192E',
  approval: '#0080C0',
  hero: '#0080C0',
  social: '#FF80FF',
  car: '#02C4B0',
};

const iconMap: Record<string, ComponentType> = {
  'fa-volume-control-phone': PhoneOutlined,
  'fa-ticket': TagOutlined,
  'fa-envelope': MailOutlined,
  'fa-flag': FlagOutlined,
  'fa-thumbs-up': LikeOutlined,
  'fa-bolt': ThunderboltOutlined,
  'fa-university': BankOutlined,
  'fa-hashtag': NumberOutlined,
  'fa-usd': DollarCircleOutlined,
  'fa-users': TeamOutlined,
};

export namespace GeekSkill {
  export type Props =
    | {
        name: string;
        icon: string;
        type: string;
        inTraining: boolean;
        loading?: false;
      }
    | { loading: true };

  export const $: FC<Props> = (props) => {
    if (props.loading)
      return (
        <Card className={styles.geekskill__card}>
          <Skeleton active avatar={{ shape: 'square', size: 'default' }} title={false} paragraph={{ rows: 2 }} />
        </Card>
      );

    const { name, icon, type, inTraining } = props;

    const Icon = iconMap[icon];

    return (
      <Card className={cx(styles.geekskill__card, inTraining && styles.geekskill__card_inprogress)}>
        <Card.Meta
          avatar={<Avatar style={{ backgroundColor: colorMap[type] }} shape="square" icon={Icon ? <Icon /> : null} />}
          title={name || 'No data'}
          description={inTraining ? 'In progress' : 'Achieved'}
        />
      </Card>
    );
  };
}
